import React from "react";
import PropTypes from "prop-types";
import { Alert } from "react-bootstrap";

export const PendingFermentationAlert = ({ device, onResume, onDismiss }) => {
  if (!device) return null;

  return (
    <div className="col-md-12">
      <Alert bsStyle="warning">
        A fermentation change on {device.title || device.serial_number} was
        interrupted.
        <button className="btn btn-link" onClick={onResume}>
          Resume
        </button>
        <button className="btn btn-link" onClick={onDismiss}>
          Dismiss
        </button>
      </Alert>
    </div>
  );
};

PendingFermentationAlert.propTypes = {
  device: PropTypes.shape({
    title: PropTypes.string,
    serial_number: PropTypes.string,
    uuid: PropTypes.string,
  }),
  onResume: PropTypes.func.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

PendingFermentationAlert.defaultProps = {
  device: null,
};

export default PendingFermentationAlert;
